module.exports = __webpack_public_path__ + "static/media/pdf.144a8424.svg";